import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import Store from './components/Store';
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={Store}>
    <App />
  </Provider>
);